<template>
	<Row class="height-100 width-100 inner-preview pt-7 px-3 pb-4 flex-justify-space-between">
		<Col class="left-side-container height-100 flex-justify-space-between">
			<h5 class="preview-text"><slot name="description" /></h5>
			<slot name="left-bottom" />
		</Col>
		<Row style="width: 25px" />
		<Col class="right-side-container">
			<SIcon :name="iconName" />
			<Col class="width-100 preview-wrapper">
				<slot name="floating-card" />
			</Col>
		</Col>
	</Row>
</template>
<script>
export default { name: 'FeatureDescriptionPreviewTemplate', props: { iconName: { type: String } } };
</script>
<style scoped lang="scss">
.preview-text {
	color: #838385;
}
.preview-wrapper {
	height: 0;
	position: relative;
}
.right-side-container {
	width: 55%;
}
.left-side-container {
	width: 45%;
}
</style>
